import { Help, Notifications, Settings } from "@mui/icons-material";
import MenuIcon from '@mui/icons-material/Menu';
import { Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AccountDetails from "./accountDetails";
import { useStyle } from "./style";
import MenuDrawer from "./menuDrawer";
import axios from "axios";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import helpbutton from "../../../assets/images/help.png"
const Header = () => {
  const classes = useStyle();
  const trigger = useSelector((state) => state.trigger);
  const userName = localStorage.getItem('username')
  const [open, setOpen] = useState(false)
  const outletId = localStorage.getItem('outlet_id')
  const outletName = localStorage.getItem('outlet_name')
    const roleId = localStorage.getItem("role_id")

console.log(trigger,'Header Trigger')
  return (
    <Grid  className={classes.headerGrid}
      sx={{
        width: trigger.isOpen ? `calc(100% - 270px)` : `calc(100% - 90px)`,
      }}
    >
      
      
      
      
      <Grid container sx={{display:"flex" ,alignItems:"center"}}>
        <Grid item xs={3} >
          <IconButton className={classes.menuGrid} onClick={()=>setOpen(true)}><MenuIcon/></IconButton>
        </Grid>
        <Grid item xs={6} sx={{display:"flex",justifyContent:"center"}}>
          {outletName ?  <Typography className={classes.userName}>{outletName}</Typography>  : <Typography sx={{marginInline:10,fontWeight:600,fontSize:20,color:"#A06EE1"}}> WareHouse</Typography> }
        </Grid>
      
        <Grid item xs={3} sx={{display:"flex",justifyContent:"end", alignItems:'center'}}>
            {roleId != 1 && roleId != 2 ?  null :  
               <Typography
  className={classes.userName}
  sx={{ textTransform: 'capitalize', cursor: 'pointer' }}
  onClick={() => window.open('https://bluekodehelpdesk.zohodesk.in/portal/', '_blank')}
>
  {/* Help */}
  <img src = {helpbutton} />
</Typography>
                          }


        <Typography className={classes.userName} sx={{textTransform:'capitalize'}}>{userName}</Typography>
          <AccountDetails />
        </Grid>
      </Grid>
      <Grid item sx={{maxWidth:400, width:'100%', height:'100%'}}><MenuDrawer open={open} onClose={setOpen}/></Grid>
    </Grid>
  );
};

export default Header;
